<template>
    <!-- component -->
    <div class="leading-loose md:w-2/3 mx-auto p-10 bg-white rounded shadow-xl">
        <h2 class="uppercase text-2xl font-bold text-center">{{ __('Recapitulatif') }}</h2>
        <div class="mt-4">
            <table class="w-full text-sm lg:text-base">
                <thead>
                <tr class="h-12 uppercase text-lg">
                    <th class="text-left">{{ __('Produit') }}</th>
                    <th class="text-right">{{ __('Prix') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in panier">
                    <td class="w-3/6">
                        <template v-if="item.attributes.categorie.par_combinaison">
                            <p class="font-bold text-cavilam-primary" v-html="__(item.attributes.categorie.slug)"></p>
                            <div v-for="(programme, key) in item.attributes.programmes">
                                <p class="font-bold" v-if="key < 1">{{ __('module_matin') }}</p>
                                <p class="font-bold" v-else>{{ __('module_apres_midi') }}</p>
                                <p class="text-sm">{{ __(programme.produit.slug) }} <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span></p>
                                <p v-if="key >= 1" class="ml-2 text-gray-700 text-sm">
                                    <template v-if="programme.produit.par_semaines">
                                        <span  v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else-if="!programme.date_fin">
                                        <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else>
                                        <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                    </template>
                                </p>
                            </div>
                        </template>
                        <template v-else-if="item.attributes.produit.enfants && item.attributes.produit.enfants.length">
                            <p class="font-bold text-cavilam-primary">
                                <span v-html="__(item.attributes.produit.slug)"></span>
                                <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span>
                            </p>
                            <div v-for="(programme, key) in item.attributes.programmes">
                                <p class="ml-2 text-gray-700" v-if="!key">
                                    <template v-if="programme.produit.par_semaines">
                                        <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else-if="!programme.date_fin">
                                        <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else>
                                        <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                    </template>
                                    <template v-if="programme.produit.par_semaines">
                                        - {{ __('Duree_de_formation') }} : {{ item.quantity }}
                                        <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                        <span v-else>{{ __('lecons') }}</span>
                                    </template>
                                </p>
                                <p class="my-1" v-if="!key" v-html="__('modules_choisis')"></p>
                                <p class="text-sm" v-if="!key || (item.attributes.programmes[key-1].produit.slug !== programme.produit.slug)"><span v-html="__(programme.produit.slug)"></span></p>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(programme, key) in item.attributes.programmes">
                                <p class="font-bold text-cavilam-primary" v-if="!key || (item.attributes.programmes[key-1].produit.slug !== programme.produit.slug)">
                                    <span v-html="__(programme.produit.slug)"></span>
                                    <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span>
                                </p>
                                <p class="ml-2 text-gray-700">
                                    <template v-if="programme.produit.par_semaines">
                                        <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else-if="!programme.date_fin">
                                        <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else>
                                        <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                    </template>
                                    <template v-if="programme.produit.par_semaines">
                                        - {{ __('Duree_de_formation') }} : {{ item.quantity }}
                                        <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                        <span v-else>{{ __('lecons') }}</span>
                                    </template>
                                </p>
                            </div>
                        </template>
                        <div v-for="detail in item.attributes.produit.details"
                             class="ml-4 flex text-sm text-gray-600">
                            <template v-if="montrerDetail(detail, item.attributes.etapes)">
                                <p class="w-5/6 italic" v-html="__(detail.detail)"></p>
                                <p class="w-1/6 text-center italic">{{ detail.prix }} €</p>
                            </template>
                        </div>
                        <template v-if="item.attributes.etapes && Object.keys(item.attributes.etapes).length">
                            <button class="font-semibold text-cavilam-secondary" @click="voirOptions(item.id)">{{ __('voir_options_prises') }}</button>
                            <div v-show="affichageOptions === item.id">
                                <template v-for="etape in item.attributes.etapes">
                                    <div class="mt-2">
                                        <h2 class="font-bold uppercase" v-html="__('etape_'+etape.nom)"></h2>
                                        <p v-if="etape.options.length || Object.keys(etape.options).length" v-for="option in etape.options">
                                            <template v-if="option && option.valeur && Object.keys(option.valeur).length && option.valeur">
                                                <span class="font-semibold text-sm" v-if="__(option.libelle)" v-html="'- '+__(option.libelle)"></span>
                                                <br v-if="__(option.libelle)" />
                                                <div v-if="Array.isArray(option.valeur)">
                                                    <span v-for="(valeur, index) in option.valeur" :key="index" class="text-xs" v-html="__(valeur.name) + ', '"></span>
                                                </div>
                                                <span v-else-if="option.valeur.value" class="text-xs" v-html="__(option.valeur.value)"></span>
                                                <span v-else class="text-xs" v-html="__(option.valeur)"></span>
                                            </template>
                                        </p>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </td>
                    <td class="w-1/6 text-right">
                            <span class="text-cavilam-primary font-semibold text-sm lg:text-base font-medium">
                                {{ montantItem(item.id) }} €
                            </span>
                    </td>
                </tr>
                <tr v-for="etape in etapes">
                    <td class="w-3/6">
                        <p class="font-bold text-cavilam-primary" v-html="__(etape.nom)"></p>
                    </td>
                    <td class="w-1/6 text-right">
                        <span class="text-cavilam-primary font-semibold text-sm lg:text-base font-medium">
                            {{ montantEtapeCommande(etape) }} €
                        </span>
                    </td>
                </tr>
                <tr v-if="montantReduit > 0.00">
                    <td class="w-5/6 text-2xlfont-semibold text-right">{{ __(promo) }}</td>
                    <td class="w-1/6 text-right text-cavilam-primary text-sm lg:text-base font-medium">- {{ montantReduit.toFixed(2) }} €</td>
                </tr>
                <tr class="relative" :class="{'text-red-700': free_frais_inscription}">
                    <td class="w-5/6 text-2xl font-semibold text-right">{{ __('frais_inscription') }}</td>
                    <td class="w-1/6 text-right text-cavilam-primary text-sm lg:text-base font-medium" :class="{'text-red-700': free_frais_inscription}">{{ frais_inscription }} €</td>
                    <div class="absolute right-0 h-0.5 w-full bg-red-700 top-1/2" v-if="free_frais_inscription"></div>
                </tr>
                <tr v-if="frais_transfert">
                    <td class="w-5/6 text-2xl font-semibold text-right">{{ __('frais_transfert') }}</td>
                    <td class="w-1/6 text-right text-cavilam-primary text-sm lg:text-base font-medium">{{ fraisTransfert }} €</td>
                </tr>
                </tbody>
            </table>
        </div>
        <hr class="my-6">
        <form   @submit.prevent="submit">
            <div class="mt-4">
                <label class="block text-lg text-gray-600 font-semibold">{{ __('Civilite') }}</label>
                <div class="flex flex-row">
                    <label for="madame" class="inline-flex items-center mx-2">
                        <input onclick="return false;" v-model="form.civilite" value="madame" type="radio" name="civilite" id="madame" class="form-radio h-5 w-5 text-cavilam-primary opacity-75" readonly><span class="ml-2 text-gray-700">{{ __('Madame') }}</span>
                    </label>
                    <label for="monsieur" class="inline-flex items-center mx-2">
                        <input onclick="return false;" v-model="form.civilite" value="monsieur" type="radio" name="civilite" id="monsieur" class="form-radio h-5 w-5 text-cavilam-primary opacity-75" readonly><span class="ml-2 text-gray-700">{{ __('Monsieur') }}</span>
                    </label>
                    <label for="autre" class="inline-flex items-center mx-2">
                        <input onclick="return false;" v-model="form.civilite" value="autre" type="radio" name="civilite" id="autre" class="form-radio h-5 w-5 text-cavilam-primary opacity-75" readonly><span class="ml-2 text-gray-700">{{ __('Autre') }}</span>
                    </label>
                </div>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Prenom" name="firstname" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Nom" name="lastname" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <nationality-selector :liste="nationalites" :readonly="true"></nationality-selector>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <label class="text-sm block text-cavilam-primary border-cavilam-primary font-semibold" for="date_naissance">{{ __('date_naissance') }}</label>
                <input v-model="form.date_naissance" min="1900-01-01" :max="new Date().toISOString().split('T')[0]" :class="{'border-red-500':form.errors.date_naissance}" class="w-full px-2 py-2 text-gray-700 rounded" id="date_naissance" name="date_naissance" type="date" readonly>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Email" name="email" type="email" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <profession-selector :liste="professions" :readonly="true" :required="false"></profession-selector>
            </div>
            <div class="mt-4">
                <input-form libelle="Adresse" name="adresse" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Ville" name="ville" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Code_postal" name="code_postal" :readonly="true"></input-form>
            </div>
            <div class="mt-4">
                <pays-selector :libelle="'Pays'" :name="'pays'" :liste="pays" :readonly="true"></pays-selector>
            </div>
            <div class="mt-4">
                <label class="inline-flex items-center mt-3">
                    <input onclick="return false;" v-model="form.adresse_facturation_differente" name="adresse_facturation_differente" type="checkbox" class="form-checkbox h-5 w-5 text-cavilam-primary opacity-75 border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('cocher_pour_renseigner_une_adresse_de_facturation_differente') }}</span>
                </label>
            </div>
            <div v-if="form.adresse_facturation_differente">
                <div class="mt-4">
                    <input-form libelle="Adresse_facturation" name="adresse_facturation" :readonly="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Ville_facturation" name="ville_facturation" :readonly="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2">
                    <input-form libelle="Code_postal_facturation" name="code_postal_facturation" :readonly="true"></input-form>
                </div>
                <div class="mt-2 mb-4">
                    <pays-selector :libelle="'Pays_facturation'" :name="'pays_facturation'" :liste="pays" :readonly="true"></pays-selector>
                </div>
            </div>
            <template v-if="contientExamen">
                <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Ville_naissance" name="ville_naissance" :readonly="true"></input-form>
                </div>
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <langue-selector :libelle="'langue_maternelle'" :name="'langue_maternelle'" :readonly="true"></langue-selector>
                </div>
                <div class="mt-4">
                    <pays-selector :libelle="'Pays_naissance'" :name="'pays_naissance'" :liste="pays" :readonly="true"></pays-selector>
                </div>
            </template>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Mobile" name="mobile" :readonly="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Telephone" name="telephone" :readonly="true"></input-form>
            </div>
            <div class="mt-4">
                <label class="block text-lg text-gray-600 font-semibold">{{ __('etes_vous_deja_venu_au_cavilam') }}</label>
                <div class="flex flex-row">
                    <label for="oui" class="inline-flex items-center mx-2">
                        <input onclick="return false;" v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="true" id="oui" class="form-radio h-5 w-5 text-cavilam-primary border-cavilam-primary opacity-75" readonly><span class="ml-2 text-gray-700">Oui</span>
                    </label>
                    <label for="non" class="inline-flex items-center mx-2">
                        <input onclick="return false;" v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="false" id="non" class="form-radio h-5 w-5 text-cavilam-primary border-cavilam-primary opacity-75" readonly><span class="ml-2 text-gray-700">Non</span>
                    </label>
                </div>
            </div>
            <div v-if="form.est_deja_client" class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="En_quelle_annee" name="annee_venue" :readonly="true"></input-form>
            </div>
            <div v-if="showMotifInscription" class="mt-4 w-full">
                <label class="text-sm block text-cavilam-primary font-semibold" for="motif_dinscription">
                    {{ __('question_motif_inscription_examen') }} <sup class="text-red-500">*</sup>
                </label>
                <select id="motif_dinscription" v-model="form.motif_dinscription"
                        name="motif_dinscription"
                        class="w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary pointer-events-none opacity-75"
                        required>
                    <option :value="null"> -- {{ __('veuillez_selectionner_un_motif_inscription') }} -- </option>
                    <option v-for="option in motifInscriptionOptionsWithLabels" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.motif_dinscription}">{{ __(form.errors.motif_dinscription) }}</p>
            </div>
            <div v-if="uploadCV" class="hidden">
                <input-form libelle="upload_cv" name="cv" :readonly="true"></input-form>
            </div>
            <div v-if="uploadLM" class="hidden">
                <input-form libelle="upload_lm" name="lm" :readonly="true"></input-form>
            </div>
            <template v-if="contientExamen">
                <div class="mt-4 w-full">
                    <input-form libelle="Numero_candidat" name="numero_candidat" :readonly="true"></input-form>
                </div>
                <div class="mt-4">
                    <p class="text-sm font-semibold text-cavilam-primary" v-html="__('piece_jointe_description')"></p>
                    <p class="text-xs">
                        <i class="fa" :class="{'fa-times': !form.pj, 'fa-check': form.pj}"></i>
                        {{ __('piece_jointe_1') }}
                    </p>
                    <p class="text-xs">
                        <i class="fa" :class="{'fa-times': !form.pj_facultative, 'fa-check': form.pj_facultative}"></i>
                        {{ __('piece_jointe_2') }}
                    </p>
                </div>
            </template>
            <div class="mt-2">
                <label for="newsletter" class="inline-flex items-center mt-3">
                    <input onclick="return false;" v-model="form.newsletter" :class="{'border-red-500':form.errors.newsletter}" name="newsletter" type="checkbox" id="newsletter" class="form-checkbox h-5 w-5 text-cavilam-primary opacity-75 border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('acceptation_newsleter') }}</span>
                </label>
            </div>
            <div class="mt-2">
                <label for="acceptation_traitement_donnees" class="inline-flex items-center mt-3 leading-5">
                    <input onclick="return false;" v-model="form.acceptation_traitement_donnees" :class="{'border-red-500':form.errors.acceptation_traitement_donnees}" name="acceptation_traitement_donnees" type="checkbox" id="acceptation_traitement_donnees" class="form-checkbox h-5 w-5 text-cavilam-primary opacity-75 border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('acceptation_traitement_donnees') }}</span>
                </label>
            </div>
            <div>
                <label for="acceptation_cgv" class="inline-flex items-center mt-3">
                    <input onclick="return false;" v-model="form.acceptation_cgv"  :class="{'border-red-500':form.errors.acceptation_cgv}" name="acceptation_cgv" type="checkbox" id="acceptation_cgv" class="form-checkbox h-5 w-5 text-cavilam-primary opacity-75 border-cavilam-primary"><span class="ml-2 text-gray-700"><span v-html="__('acceptation_cgv')"></span></span>
                </label>
            </div>
            <div class="text-center">
                <p class="text-2xl font-bold text-cavilam-secondary">{{ __('Total') }}</p>
                <p class="text-xl font-semibold">{{ montantTotal }} €</p>
            </div>
            <div v-if="!sipsData" class="md:w-2/3 mx-auto text-center my-4">
                <breeze-button

                    class="inline-flex mx-4 items-center px-4 py-2 rounded-md focus:shadow-outline-gray
                    transition ease-in-out duration-150 uppercase font-semibold border-transparent"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    @click.prevent="submitFlywire"
                    id="TM-payement-flywire"
                    >
                    {{ __('payer') }}
                </breeze-button>
                <inertia-link :href="route('panier.index')"
                              class="inline-flex mx-2 items-center px-2 py-1 bg-red-600
                      border border-transparent rounded-md font-semibold text-2xs text-white
                      uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none
                      focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                      id="TM-cancel-payement-flywire"
                      >
                    {{ __('annuler') }}
                </inertia-link>




            </div>
            <button
                class="text-xs mt-6 float-right"
                :disabled="form.processing"
                id="TM-payement-sogenactif"
                >
                {{ __('payer par sogenactif') }}
            </button>
        </form>
        <p v-if="sipsError">
            Une erreur a eu lieu. Veuillez revenir à l'étape précédente et réessayer.
            <br /> Si le problème persiste, veuillez contacter l'administrateur du site.
        </p>
        <form ref="sipsForm" method="POST" :action="sipsLink ? sipsLink : ''">
            <input type="hidden" name="Data" :value="sipsData ? sipsData.encodedData : ''"/>
            <input type="hidden" name="InterfaceVersion" :value="sipsData ? sipsData.sipsVersion : ''"/>
            <input type="hidden" name="Seal" :value="sipsData ? sipsData.sealData : ''"/>
            <input type="hidden" name="SealAlgorithm" :value="sipsData ? sipsData.sealAlgorithm : ''"/>
            <input type="hidden" name="Encode" value="base64"/>
        </form>
        <button ref="checkoutButton" id="checkout-button"  type="hidden" name="flywireRender"></button>
    </div>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'
import NationalitySelector from '@/Components/NationalitySelector'
import PaysSelector from "../../Components/PaysSelector";
import ProfessionSelector from "@/Components/ProfessionSelector";
import LangueSelector from "@/Components/LangueSelector";
import InputForm from "@/Components/InputForm";
import InputFile from "@/Components/InputFile";

export default {
    layout: App,
    name: "Recapitulatif",
    components: {
        PaysSelector,
        BreezeButton,
        NationalitySelector,
        ProfessionSelector,
        LangueSelector,
        InputForm,
        InputFile,
    },
    props: {
        donneesPersonnelles: Object,
        panier: Object,
        promo: String,
        flywireData: Object,
        montantReduit: Number,
        frais_inscription: Number,
        frais_transfert: Number,
        sipsData: Object,
        sipsLink: String,
        contientExamen: Boolean,
        uploadCV: Boolean,
        uploadLM: Boolean,
        pays: Array,
        nationalites: Array,
        professions: Array,
        contientTCF: Boolean,
        motifInscriptionOptions: {
            type: Array,
            default: () => [],
        },
        etapes: Array,
    },
    setup(props) {
        props.donneesPersonnelles.panier = props.panier;
        props.donneesPersonnelles.promo = props.promo;
    },
    data() {
        return {
            form: this.$inertia.form({...this.donneesPersonnelles, ...{contient_examen: this.contientExamen, preserveScroll: true, etapes: this.etapes}}),
            sipsError: false,
            affichageOptions: '',
            free_frais_inscription: false,
        }
    },
    mounted() {

        // Create a new script element
        const script = document.createElement('script');

        // Set the source of the script to the Flywire Checkout library
        script.src = 'https://payment.flywire.com/assets/js/checkout.js';

        // Append the script to the document head
        document.head.appendChild(script);

        // Optionally, you can include an onload event to know when the script is loaded
        script.onload = () => {
            console.log('Flywire Checkout script loaded');
        }

        let date = new Date();
        let start = new Date("2025-04-22");
        let end = new Date("2025-05-04");

        if (date >= start && date <= end) {
            for (let itemID in this.panier) {
                let item = this.panier[itemID];
    
                if (item.attributes.categorie.type_id == 2) {
                    this.free_frais_inscription = true;
                    break;
                }
            }
        }
    },
    methods: {
        voirOptions(id) {
            if(this.affichageOptions !== id)
                this.affichageOptions = id;
            else
                this.affichageOptions = '';
        },
        montrerDetail(detail, etapes) {

            if(etapes && Object.keys(etapes).length && detail && detail.conditions && detail.conditions.length) {
                for(let condition in detail.conditions) {
                    let found = false;

                    for(let etape in etapes) {
                        for(let option in etapes[etape].options) {
                            if(detail.conditions[condition].parent_option_id === etapes[etape].options[option].valeur.option_id) {
                                if(detail.conditions[condition].enfant_option_id !== etapes[etape].options[option].valeur.id)
                                    return false;

                                found = true;
                            }
                            if(found) break;
                        }
                        if(found) break;
                    }
                }
            }

            return true;
        },
        submit() {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: "EUR",
                    value: this.montantSousTotal,
                    payment_type: "Sogenactif",
                    items: this.TM_get_items()
                }
            });
            this.form.post(this.route('paiement.traitement'), this.form)
        },
        submitFlywire() {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: "EUR",
                    value: this.montantSousTotal,
                    payment_type: "Flywire",
                    items: this.TM_get_items()
                }
            });
            this.form.post(this.route('paiement.traitementFlywire'), this.form)
        },

        montantItem: function (id) {
            let prix = parseFloat(0);
            prix += parseFloat(this.panier[id].price);
            prix += parseFloat(this.montantOptions(id));
            return parseFloat(prix).toFixed(2);
        },
        montantOptions(id) {
            let prix = parseFloat(0);
            for(let etape in this.panier[id].attributes.etapes) {
                let elemEtape = this.panier[id].attributes.etapes[etape];

                // Les frais de transferts seront à régler sur place
                if (elemEtape.nom === 'transfert') continue;

                for(let option in elemEtape.options) {

                    if(!elemEtape.options[option] || !elemEtape.options[option].valeur || typeof elemEtape.options[option].valeur !== 'object' || !elemEtape.options[option].valeur.montant)
                        continue;

                    if(elemEtape.options[option].valeur.type === 'number') {
                        prix += parseFloat(elemEtape.options[option].valeur.montant) * parseFloat(elemEtape.options[option].valeur.value);
                    } else {
                        prix += parseFloat(elemEtape.options[option].valeur.montant);
                    }

                }
            }
            return parseFloat(prix).toFixed(2);
        },
        montantEtapeCommande(etape) {
            let prix = parseFloat(0);
            for(let option of etape.options) {
                for(let enfant of option.enfants) {
                    if(enfant.id != option.value) continue;
                    if(!enfant.montant) continue;
                    prix += parseFloat(enfant.montant);
                }
                if(!option.montant) continue;
                prix += parseFloat(option.montant);
            }
            return parseFloat(prix).toFixed(2);
        },

        // #region Google Analytics (Tag Manager)
        TM_get_items() {
            let items = [];
            for(let itemId in this.panier) {
                let item = this.panier[itemId];
                let tarif = item.attributes.produit.tarifs.find(tarif => {
                    return tarif.annee == (new Date()).getFullYear();
                });
                if (!tarif) tarif = item.attributes.produit.tarifs[0];

                items.push({
                    item_id: item.attributes.produit.id,
                    item_name: this.__(item.attributes.produit.slug),
                    item_category: this.__(item.attributes.type.slug),
                    item_list_id: item.attributes.categorie.id,
                    item_list_name: this.__(item.attributes.categorie.slug),
                    price: tarif.montant,
                    quantity: item.quantity,
                });
            }
            return items;
        },
        getMotifInscriptionLabel(value) {
            const aliases = {
                renouvellement_carte_de_resident: 'carte_de_sejour_de_10_ans',
                renouvellement_permis_de_residence: 'carte_de_sejour_pluriannuelle',
            };
            const translationKey = aliases[value] ?? value;
            const translated = this.__(translationKey);

            if (translated === translationKey && translationKey !== value) {
                return this.__(value);
            }

            return translated;
        },
        // #endregion Google Analytics (Tag Manager)
    },
    computed: {
        showMotifInscription() {
            return this.contientExamen && this.motifInscriptionOptionsWithLabels.length > 0;
        },
        motifInscriptionOptionsWithLabels() {
            return (this.motifInscriptionOptions || []).map((optionValue) => ({
                value: optionValue,
                label: this.getMotifInscriptionLabel(optionValue),
            }));
        },
        montantSousTotal() {
            let prix = parseFloat(0);
            for(let itemId in this.panier)
                prix += parseFloat(this.montantItem(itemId));

            return parseFloat(prix).toFixed(2);
        },
        montantReduction() {
            if(this.promo && Object.keys(this.promo).length && this.promo.constructor === Object)
                return parseFloat(parseFloat(this.promo.montant)).toFixed(2);
            else
                return parseFloat(0).toFixed(2)
        },
        fraisInscription() {
            if(this.promo && Object.keys(this.promo).length && this.promo.constructor === Object && (this.promo.frais_inscription != undefined || this.promo.frais_inscription != null))
                return parseFloat(parseFloat(0) + parseFloat(this.promo.frais_inscription)).toFixed(2);
            else
                return parseFloat(parseFloat(0) + parseFloat(this.frais_inscription)).toFixed(2);
        },
        fraisTransfert() {
            if (!this.frais_transfert) return 0;
            return parseFloat(this.frais_transfert).toFixed(2);
        },
        montantTotalEtapeCommande() {
            let prix = parseFloat(0);
            if (!this.etapes) return 0;
            for (let etape of this.etapes) {
                for (let option of etape.options) {
                    for (let enfant of option.enfants) {
                        if (enfant.id != option.value) continue;
                        if (!enfant.montant) continue;
                        prix += parseFloat(enfant.montant);
                    }
                    if (!option.montant) continue;
                    prix += parseFloat(option.montant);
                }
            }
            return parseFloat(prix).toFixed(2);
        },
        montantTotal() {
            if (this.free_frais_inscription) {
                return parseFloat((parseFloat(this.montantSousTotal) + parseFloat(this.fraisTransfert) + parseFloat(this.montantTotalEtapeCommande)) - parseFloat(this.montantReduction)).toFixed(2);
            }
            
            return parseFloat(
                (
                    parseFloat(this.fraisInscription) + 
                    parseFloat(this.montantSousTotal) + 
                    parseFloat(this.fraisTransfert) +
                    parseFloat(this.montantTotalEtapeCommande)
                ) - 
                parseFloat(this.montantReduit)
            ).toFixed(2);
        }
    },
    watch: {
        sipsData: {
            handler(newValue){
                // Présence de tous les champs nécéssaires
                if(newValue && this.sipsLink &&
                    newValue.hasOwnProperty('encodedData') &&
                    newValue.hasOwnProperty('sipsVersion') &&
                    newValue.hasOwnProperty('sealData') &&
                    newValue.hasOwnProperty('sealAlgorithm')
                ){
                    this.$nextTick(() => { this.$refs.sipsForm.submit(); });
                }
                else if(newValue) {
                    // valeurs présentes mais invalide
                    this.sipsError = true;
                }
            },
            immediate: true
        },
        motifInscriptionOptions: {
            handler(newValue) {
                if (!this.form || !this.form.motif_dinscription) {
                    return;
                }

                if (!Array.isArray(newValue) || !newValue.includes(this.form.motif_dinscription)) {
                    this.form.motif_dinscription = null;
                }
            },
            immediate: true,
        },
        flywireData: {handler(newValue){
                if(newValue){
                    flywire.Checkout.render(newValue, "#checkout-button");
                    this.$nextTick(() => {

                        this.$refs.checkoutButton.click();
                    });
                }

            }

        },
    }
}
</script>

<style scoped>

</style>
